import { useEffect, useState } from "react";
import { authContext } from "./context";

import { setCookie, getCookie, deleteCookie, clearAllCookies } from "../../utils/cookies";
import { dispatchCustomEvent } from "../../utils/dispatch";
import { cacheManager } from "../../infrastructure/cache-manager";

import { signInWithEmailAndPassword } from "../../usecases/auth-usecase";
import { getProfile } from "../../usecases/users-usecases";


export function AuthContext({ children }) {

    const [user, setUser] = useState(null);

    async function logIn(email, password) {
        // Limpieza preventiva de impersonación o residuos de cuentas previas
        deleteCookie('owner_user_id');
        deleteCookie('cid');
        if (typeof window !== 'undefined') {
            window.localStorage.removeItem('impersonate');
            window.localStorage.removeItem('cid');
        }
        cacheManager.clear();

        const auth = await signInWithEmailAndPassword(email, password)
        setCookie('token', auth.idToken, 30)
        const now = new Date().getTime();
        setCookie('tokenTimeStamp', now, 30)
        setCookie('refreshToken', auth.refreshToken, 30)
        const profile = await getProfile(auth.uid, null);
        setUser(profile);
        setCookie('data', JSON.stringify(profile), 30);
        dispatchCustomEvent('popup', { message: "Bienvenido", type: "success" });
    }

    function signUp(email, password) {
        console.log("🚀 ~ file: state.js:20 ~ signUp ~ email, password:", email, password)
    }

    function logOut() {
        if (typeof window !== 'undefined') {
            window.localStorage.clear();
            window.sessionStorage.clear();
        }
        clearAllCookies();
        cacheManager.clear();
        setUser(null);
        if (typeof window !== 'undefined' && 'caches' in window) {
            caches.keys().then(names => {
                names.forEach(name => caches.delete(name));
            }).catch(e => console.error("Error clearing caches on logout:", e));
        }
    }

    useEffect(() => {
        setUser(getCookie('data') ? JSON.parse(getCookie('data')) : null)
    }, [])

    return (
        <authContext.Provider
            value={{ user, logIn, signUp, logOut }}
        >
            {children}
        </authContext.Provider>
    );
}

export default AuthContext;

